import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.disable,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 35
  const h = 35
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="35" height="35" fill="#f5f5f50" />
      <path
        d="M24.25 11L10.75 24.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.25 24.25L10.75 10.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
